import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Patient } from 'src/app/modules/patient/models/patient.model';
import { PatientService } from 'src/app/modules/patient/services/patient.service';
import { Assessment } from '../../models/assessment.model';
import { distinctUntilChanged, first, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DirectusFile } from 'src/app/shared/models/directus-file.model';

@Component({
    selector: 'app-assessment-patient-view-detail',
    templateUrl: './assessment-patient-view-detail.component.html',
    styleUrl: './assessment-patient-view-detail.component.scss'
})
export class AssessmentPatientViewDetailComponent {
    public assessment: Assessment;
    public patient: Patient;
    public idPatient: string;

    constructor(
        private readonly router: Router,
        private activatedRoute: ActivatedRoute,
        private patientService: PatientService,
    ) {

    }

    ngOnInit() {
        // Get assessment 
        this.router.events.pipe(
            map(() => this._getDeepestChild(this.activatedRoute)),
            map(route => {
                const response = route.snapshot.data;
                const idFromRoute = route.snapshot.paramMap.get('idPatient');
                if (response?.['assessment']) {
                    this.assessment = response['assessment'];
                    return this.assessment.patient?.id || null;
                }
                return idFromRoute;
            }),
            distinctUntilChanged()
        ).subscribe(idPatient => {
            if (idPatient && idPatient !== this.idPatient) {
                this.idPatient = idPatient;
                this.patientService.view(idPatient).pipe(first()).subscribe(patient => {
                    this.patient = patient;
                });
            }
        });
    }

    getAvatar() {
        if (this.patient.user.avatar) return environment.apiHost + '/assets/' + (this.patient.user.avatar as DirectusFile).id;
        else return '/assets/media/avatars/blank.png';
    }


    /***************************
    ***** PRIVATE FUNCTIONS ****
    ****************************/
    private _getDeepestChild(route: ActivatedRoute): ActivatedRoute {
        while (route.firstChild) {
            route = route.firstChild;
        }
        return route;
    }
}